export default "__VITE_ASSET__RQ7N9_En__"